import { AssetLogo, Toggle } from '@toggle/design-system';
import React from 'react';

import { ChartEntity } from '~/types/timeseries.types';

import * as S from './ChartTypeSelectorItem.style';

export interface ChartTypeSelectorItemProps {
  entity: ChartEntity;
  isChecked: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export const ChartTypeSelectorItem = ({
  entity,
  isChecked,
  onClick,
  disabled = false,
}: ChartTypeSelectorItemProps) => {
  return (
    <S.Wrapper>
      <S.AssetWrapper>
        <AssetLogo entity={entity} isDarkTheme size={20} />
        <S.AssetTicker>{entity.formattedTicker}</S.AssetTicker>
      </S.AssetWrapper>
      <Toggle
        data-testid={`${entity.formattedTicker}toggle`}
        isChecked={isChecked}
        onClick={onClick}
        disabled={disabled}
      />
    </S.Wrapper>
  );
};
